import { useMemo } from 'react';
import { useNavComponentsManager } from './useNavComponentsManager';
export const useComponentState = name => {
  const {
    componentStatesMap
  } = useNavComponentsManager();
  return useMemo(() => componentStatesMap[name], [componentStatesMap, name]);
};